import React, {useContext} from "react";
import { NavLink, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { IsMobileContext } from "../../../isMobileContext";
import { SET_MOBILE_DETAILS_VIEW } from "../../../Core/Actions/mobileActions";

const NavItemGame = ({ title, id, sport, markNewResults, history }) => {
  const ctx = useContext(IsMobileContext);
  const dispatch = useDispatch();

  const _onClick = () => {
    if(history){
      dispatch({
        type: SET_MOBILE_DETAILS_VIEW,
        payload: {
            gameDetailsVisible: true
        }
      });
      history.push(`/results/${id}`);
    }
  }

  if(ctx.isMobile){
    return (
      <div
      onClick={_onClick}
      className="nav-list__item nav-list__item--icon"
    >
      <span className="nav-list__icon">
        <span className={`nav-list-icon-item z-icon ${sport}`} />
      </span>
      {markNewResults ? (
        <span className="nav-list__item-mark glyphicon glyphicon-asterisk" />
      ) : null}
      <span className="nav-list__item-name">{title}</span>
    </div>
    )
  }
  return (
    <NavLink
      to={`/results/${id}`}
      activeClassName="nav-list__item--active"
      className="nav-list__item nav-list__item--icon"
    >
      <span className="nav-list__icon">
        <span className={`nav-list-icon-item z-icon ${sport}`} />
      </span>
      {markNewResults ? (
        <span className="nav-list__item-mark glyphicon glyphicon-asterisk" />
      ) : null}
      <span className="nav-list__item-name">{title}</span>
    </NavLink>
  );
};

export default withRouter(NavItemGame);
